module.exports = __webpack_public_path__ + "img/toggle-sun.09f47086.svg";